const tableOption = function () {
  return {
    stripe: true,
    page: true,
    maxHeight: "100%",
    header: false,
    index: true,
    selection: true,
    emptyText: "暂无数据",
    view: "详情",
    column: [
      {
        label: "司机",
        prop: "driverName",
        search: true,
        clearable: true
      },
      {
        label: "手机号",
        prop: "phone"
      },
      {
        label: "前车车牌",
        prop: "frontVehicleNumber"
      },
      {
        label: "车辆类型",
        prop: "vehicleTypeName"
      },
      {
        label: "园区",
        prop: "appointmentPark",
        search: true,
        searchSlot: true,
        clearable: true,
        hide: true
      },
      {
        label: "园区",
        prop: "appointmentParkName",
      },
      {
        label: "装/卸货",
        prop: "operateType",
        search: true,
        clearable: true,
        type: "select",
        dicData: [
          {
            label: '装货',
            value: 1
          },
          {
            label: '卸货',
            value: 2
          },
        ],
        formatter: function (row, value) {
          if (Number(value) === 1) {
            return "装货";
          } else if (Number(value) === 2) {
            return "卸货";
          }
          return "";
        }
      },
      {
        label: "作业日期",
        prop: "workTime",
        search: true,
        clearable: true,
        type: "datetimerange",
        hide: true
      },
      {
        label: "客户    ",
        prop: "custom",
        search: true,
        clearable: true
      },
      {
        label: "柜号",
        prop: "cabinetNumber",
        search: true,
        clearable: true
      },
      {
        label: "状态",
        prop: "workStatus",
        search: true,
        clearable: true,
        type: "select",
        dicData: [
          {
            label: '待签到',
            value: -1
          },
          {
            label: '已签到',
            value: 0
          },
          {
            label: '待入园未开始',
            value: 1
          },
          {
            label: '作业中',
            value: 2
          },
          {
            label: '完成作业',
            value: 3
          },
          {
            label: '待审批',
            value: 4
          },
          {
            label: '待出园',
            value: 5
          },
          {
            label: '已出园',
            value: 6
          },
          {
            label: '作废',
            value: 9
          },
        ],
        formatter: function (row, value) {
          if (Number(value) === -1) {
            return "待签到";
          } else if (Number(value) === 0) {
            return "已签到";
          } else if (Number(value) === 1) {
            return "待入园未开始";
          } else if (Number(value) === 2) {
            return "作业中";
          } else if (Number(value) === 3) {
            return "完成作业";
          } else if (Number(value) === 4) {
            return "待审批";
          } else if (Number(value) === 5) {
            return "待出园";
          } else if (Number(value) === 6) {
            return "已出园";
          } else if (Number(value) === 9) {
            return "作废";
          }
          return "";
        }
      },
      {
        label: "开始作业时间",
        prop: "startWorkTime"
      },
      {
        label: "结束作业时间",
        prop: "finishWorkTime"
      },
    ]
  };
};

export default tableOption;
